import { cn } from '@/lib/cn';

export interface Segment {
  value: string;
  label: string;
}

/** The TABLE|KANBAN|PIPELINE and 7D|30D|90D|ALL control. Active segment is filled with accent. */
export function Segmented({
  segments,
  value,
  onChange,
  className
}: {
  segments: Segment[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <div className={cn('inline-flex items-center gap-1 rounded border border-border bg-card p-1', className)}>
      {segments.map(segment => {
        const active = segment.value === value;
        return (
          <button
            key={segment.value}
            type="button"
            onClick={() => onChange(segment.value)}
            className={cn(
              'rounded-[3px] px-3 py-1 font-mono text-[10px] uppercase tracking-[0.1em] transition-colors cursor-pointer',
              active ? 'bg-primary text-foreground' : 'bg-transparent text-muted hover:text-foreground'
            )}
          >
            {segment.label}
          </button>
        );
      })}
    </div>
  );
}
